import { Box, Button, Grid, IconButton, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import AddIcon from '@mui/icons-material/Add';
import { deleteGroup, getListOfGroups, resetAllWinner, resetGroup } from '../AdminMenusRequests';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { SmallModal } from '../../../CustomModal/SmallModal';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import toast from 'react-hot-toast';
import { AddWinner } from './AddWinner';
import Swal from 'sweetalert2';
import { AddGroups } from './AddGroups';
import { UpdateGroup } from './UpdateGroup';

export const ListOfGroups = ({close,updateScoreBoard}) => {
    const [listOfGroups,setListOfGroups] = useState([]);
    const [selectedGroup,setSelectedGroup] = useState();

    useEffect(()=>{
        _getGroups();
    },[])
    const _getGroups = async () => {
        const res = await getListOfGroups();
        setListOfGroups(res.data.data)
    }
    const [openAddModal,setOpenAddModal] = useState(false)
    const [openUpdateModal,setOpenUpdateModal] = useState(false)
    const [openUpdateWinnerModal,setOpenUpdateWinnerModal] = useState(false)
    const handleDelete = async (item)=>{
        const toastId = toast.loading('Deleting game'); 
        const res  = await deleteGroup({id:item.id});
        if(res.data.status === 200){
            setListOfGroups(res.data.data)
            updateScoreBoard()
            toast.success(res.data.message,{
                id:toastId
            });
        }else{
            toast.error(res.data.message,{
                id:toastId
            });
        }
    }
    const handleUpdate = (item) => {
        setSelectedGroup(item)
        setOpenUpdateModal(true)

    }
    const handleResetGroup = () => {
        Swal.fire({
            icon:'question',
            title:'Confirm reseting group ?',
            text:'Action cannot be reverted',
            confirmButtonText:'Yes, I Confirm it !',
            cancelButtonText:'No, Cancel it !',
            showCancelButton:true
        }).then( async res=>{
            if(res.isConfirmed){
                const toastId = toast.loading('Resetting All Winners')

                const res = await resetGroup()
                if(res.data.status === 200){
                    setListOfGroups(res.data.data)
                    updateScoreBoard()
                    toast.success(res.data.message,{
                        id:toastId
                    });
                }else{
                    toast.error(res.data.message,{
                        id:toastId
                    });
                }
            }
        })
    }
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sx={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <Typography>List Of Groups</Typography>
                <Box sx={{display:'flex',gap:1}}>
                    <Button variant='outlined' color='secondary' startIcon={<RestartAltIcon/>} onClick={handleResetGroup}>Reset Group/s</Button>
                    <Button variant='outlined' startIcon={<AddIcon/>} onClick={()=>setOpenAddModal(true)}>Add</Button>

                </Box>
            </Grid>
            <Grid item xs={12}>
                <List sx={{maxHeight:'65vh',overflow:'auto'}}>
                {
                    listOfGroups.map((item)=>
                    <ListItem disablePadding
                        secondaryAction={
                            <Box sx={{display:'flex',gap:1}}>
                                <Tooltip title='Update'>
                                    <IconButton aria-label="edit" className='icon-btn-bordered'  color='success' onClick={()=>handleUpdate(item)}>
                                    <EditIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title='Delete'>
                                    <IconButton aria-label="delete" className='icon-btn-bordered' color='error' onClick={()=>handleDelete(item)}>
                                    <DeleteIcon />
                                </IconButton>
                                </Tooltip>
                                
                            </Box>
                        }
                    >
                        <ListItemButton>
                        <ListItemText primary={item.group_name}/>
                        </ListItemButton>
                    </ListItem>
                    )
                }
                </List>
            </Grid>
            <SmallModal open={openAddModal} close = {()=>setOpenAddModal(false)} title='Adding New Group'>
                <AddGroups close={()=>setOpenAddModal(false)} setListOfGroups ={setListOfGroups} updateScoreBoard={updateScoreBoard}/>
            </SmallModal>
            <SmallModal open={openUpdateModal} close = {()=>setOpenUpdateModal(false)} title='Adding new Games'>
                <UpdateGroup close={()=>setOpenUpdateModal(false)} setListOfGroups ={setListOfGroups} selectedGroup={selectedGroup} updateScoreBoard={updateScoreBoard}/>
            </SmallModal>
            <SmallModal open={openUpdateWinnerModal} close = {()=>setOpenUpdateWinnerModal(false)} title='Updating game winner'>
                <AddWinner close={()=>setOpenUpdateWinnerModal(false)} listOfGroups={listOfGroups} setListOfGroups ={setListOfGroups} selectedGroup={selectedGroup} updateScoreBoard={updateScoreBoard}/>
            </SmallModal>
        </Grid>
    )
}